import React, { FC, SVGAttributes } from "react"
import SVG from "../svg"

const Rock: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <SVG
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M395.138 244.757a.186.186 0 01-.033-.139l32.664-190.466a.183.183 0 01.18-.152h10.338c.08 0 .15.052.174.128l73.59 233.003a.183.183 0 01-.062.199l-54.259 42.363a.182.182 0 01-.259-.036l-62.333-84.9zM-1 371.022c0 .079.05.149.126.174l111.849 36.571a.184.184 0 00.161-.023l250.009-172.6a.182.182 0 00.077-.124l26.81-179.892a.182.182 0 00-.18-.21H166.406a.183.183 0 00-.141.067L-.958 256.714a.183.183 0 00-.042.117v114.191zm158.583 46.063l122.193 40.027a.182.182 0 00.163-.025l145.479-104.353a.182.182 0 00.046-.25l-54.536-81.155a.182.182 0 00-.255-.049l-213.09 145.805z"
                clipRule="evenodd"
            ></path>
        </SVG>
    )
}

export default Rock
